(function () {
    'use strict';

    angular
        .module('app')
        .controller('undocheckoutofunchangedchildren', undocheckoutofunchangedchildren);

    undocheckoutofunchangedchildren.$inject = ['$location', '$scope', '$rootScope', 'gridDataService', '$q', 'selectionCommandService', '$timeout', '$mdDialog', 'records', 'command', 'commandService', 'loginService', 'editEmailsService', 'zcs'];

    function undocheckoutofunchangedchildren($location, scope, $rootScope, gridDataService, $q, selectionCommandService, $timeout, $mdDialog, records, command, commandService, loginService, editEmailsService, zcs) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'undocheckoutofunchangedchildren';

        scope.undoCheckOutOfUnchangedChildrenDialogShown = false;

        scope.ACN_RELEASE_UNCHANGED_CHILDREN = 140;
        scope.xyz = {};

        scope.$on('undoCheckOutOfUnchangedChildrenButtonClicked', function (event, arg) {
            scope.onUndoCheckOutOfUnchangedChildrenButtonClicked(arg.slx);
        });

        scope.processingLabel = loginService.resourceStrings["PROCESSING"];

        //var processNode = function(data, xRefNodeModel) {
        //    angular.forEach(xRefNodeModel.childNodeList, function (childXRefNodeModel) {
        //
        //        var childId = childXRefNodeModel.childId;
        //
        //        var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
        //        var xrefFileRecordModel = data.fileItems[childId];
        //        if(xrefFileRecordModel != null && xrefFileRecordModel.opFlag == O_OUT) {
        //            var recDate = xrefFileRecordModel.fileUTCDate;
        //
        //            var detailedInfo = {
        //                filename: xrefFileRecordModel.longName,
        //                bGRev: xrefFileRecordModel.isGRev,
        //                opFlag: xrefFileRecordModel.opFlag,
        //                status: xrefFileRecordModel.status,
        //                libId: xrefFileRecordModel.libraryId,
        //                userId: xrefFileRecordModel.ownerId,
        //                lastUserId: xrefFileRecordModel.lastOwnerId,
        //                targetId: xrefFileRecordModel.pathId,
        //                workflowId: xrefFileRecordModel.wfId,
        //                workflowStepId: xrefFileRecordModel.wfStepId,
        //                defaultWorkflowId: null, // xrefFileRecordModel.SCHEMA_S_DEFWFID,
        //                originatorID: xrefFileRecordModel.origID,
        //                fileUtc: xrefFileRecordModel.fileUTCDate,
        //                fileSize: xrefFileRecordModel.fileSize64,
        //                linkType: xrefFileRecordModel.linked,
        //                bIsParent: xrefFileRecordModel.isParent,
        //                bIsChild: xrefFileRecordModel.isChild,
        //                libName: xrefFileRecordModel.libraryName,
        //                activeWorkflowName: null, //xrefFileRecordModel.SCHEMA_S_WFNAME,
        //                activeStepName: null, //xrefFileRecordModel.SCHEMA_S_STEPNAME,
        //                menuEnables: null // menuEnables[key]
        //            };
        //            var commandParams = {};
        //            var docId = null;
        //            var selectionItem = {
        //                filename: xrefFileRecordModel.longName,
        //                sortval: xrefFileRecordModel.longName,
        //                tableNumber: +xrefFileRecordModel.tableNumber,
        //                fileId: xrefFileRecordModel.fileId,
        //                majRev: +xrefFileRecordModel.majorRevision,
        //                minRev: +xrefFileRecordModel.minorRevision,
        //                detailedInfo: detailedInfo,
        //                commandParams: commandParams,
        //                docId: docId
        //            };
        //            // Add to the main list.
        //            scope.slxToCheck.list.push(selectionItem);
        //
        //            processNode(data, childXRefNodeModel);
        //        }
        //    });
        //}

        //
        //var ProcessItem = function (xrefFileRecordModel) {
        //    var O_OUT = 83; // 'S'; // OPFLAG.O_OUT
        //    if (xrefFileRecordModel != null && xrefFileRecordModel.opFlag == O_OUT) {
        //        var filePNE = xrefFileRecordModel.accessPNE;
        //        var recDate = xrefFileRecordModel.fileUTCDate;
        //        var detailedInfo = {
        //            filename: xrefFileRecordModel.longName,
        //            bGRev: xrefFileRecordModel.isGRev,
        //            opFlag: xrefFileRecordModel.opFlag,
        //            status: xrefFileRecordModel.status,
        //            libId: xrefFileRecordModel.libraryId,
        //            userId: xrefFileRecordModel.ownerId,
        //            lastUserId: xrefFileRecordModel.lastOwnerId,
        //            targetId: xrefFileRecordModel.pathId,
        //            workflowId: xrefFileRecordModel.wfId,
        //            workflowStepId: xrefFileRecordModel.wfStepId,
        //            defaultWorkflowId: null, // xrefFileRecordModel.SCHEMA_S_DEFWFID,
        //            originatorID: xrefFileRecordModel.origID,
        //            fileUtc: xrefFileRecordModel.fileUTCDate,
        //            fileSize: xrefFileRecordModel.fileSize64,
        //            linkType: xrefFileRecordModel.linked,
        //            bIsParent: xrefFileRecordModel.isParent,
        //            bIsChild: xrefFileRecordModel.isChild,
        //            libName: xrefFileRecordModel.libraryName,
        //            activeWorkflowName: null, //xrefFileRecordModel.SCHEMA_S_WFNAME,
        //            activeStepName: null, //xrefFileRecordModel.SCHEMA_S_STEPNAME,
        //            menuEnables: null // menuEnables[key]
        //        };
        //        var commandParams = {};
        //        var docId = null;
        //        var selectionItem = {
        //            filename: xrefFileRecordModel.longName,
        //            sortval: xrefFileRecordModel.longName,
        //            tableNumber: +xrefFileRecordModel.tableNumber,
        //            fileId: xrefFileRecordModel.fileId,
        //            majRev: +xrefFileRecordModel.majorRevision,
        //            minRev: +xrefFileRecordModel.minorRevision,
        //            detailedInfo: detailedInfo,
        //            commandParams: commandParams,
        //            docId: docId
        //        };
        //        // Add to the main list.
        //        var bExists = false;
        //        angular.forEach(scope.itemsToCheck, function (item) {
        //            if (item.selectionItem.fileId == selectionItem.fileId)
        //                bExists = true;
        //        });
        //        if(!bExists)
        //            scope.itemsToCheck.push({ filePNE: filePNE, selectionItem: selectionItem });
        //    }
        //}

        //var doLoadOne = function (list, workNumber) {
        //    // Each item must be a promise.
        //    var deferred = $q.defer();

        //    var si = list[workNumber];

        //    selectionCommandService.GetTreeVirtualized(
        //        si.tableNumber, si.fileId, si.majRev, si.minRev, scope.localVirtualLibraryPath).then(function (response) {
        //        //var xRefNodeModel = data.xRefTopLevelNode;
        //        //processNode(data, xRefNodeModel);
        //        //
        //        angular.forEach(response.data.fileItems, function (item) {
        //            // If this is not the parent, process it.
        //            if (si.fileId != item.fileId)
        //                ProcessItem(item);
        //        });
        //        //
        //        deferred.resolve();
        //        }, function () {
        //            deferred.reject()
        //        });
           
        //    // Return the promise for the current item.
        //    return deferred.promise;
        //}

        //// Walk through each item in the grid.
        //var doLoadLoop = function (list, workNumber) {
        //    // Each item must be a promise.
        //    var deferred = $q.defer();

        //    // Do one item.
        //    doLoadOne(list, workNumber).then(function () {
        //        // When that is done, ...
        //        // Incement the item number that we are going to work on.
        //        workNumber++;
        //        // If we are still in the list, ...
        //        if (workNumber < list.length) {
        //            // Recurse on the next item.
        //            doLoadLoop(list, workNumber).then(function () {
        //                // When that is done. Resolve the promise from before.
        //                deferred.resolve();
        //            }, function () {
        //                deferred.reject();
        //            });
        //        }
        //        else { // We are done with the list.
        //            // Resolve this item.
        //            deferred.resolve();
        //            // Return the promise.
        //            return deferred.promise;
        //        }
        //    }, function () {
        //        deferred.reject();
        //    });

        //    // Return the promise for the current item.
        //    return deferred.promise;
        //}
        //

        // On click of the Assign button.
        scope.onUndoCheckOutOfUnchangedChildrenButtonClicked = function (slx) {
            // scope
            scope.slx = slx;
            scope.xyz = { bReadyForOK: false };

            scope.gridOptions.columnDefs = [
                { name: 'Name', field: 'name', width: '20%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '20%', minWidth: '100' },
                { name: 'Data Card Changed', field: 'hasDataCardChange', width: '10%', minWidth: '100' }                
            ];

            // dialog config
            scope.heading = loginService.resourceStrings["UNDO_CHECK_OUT_OF_UNCHANGED_CHILDREN"];
            scope.docsWithDataCardChanges = "Documents with data card changes";
            scope.unselectButtonText = "Unselect"; // loginService.resourceStrings["UNSELECT_DATA_CARD_CHGS"];
            scope.selectButtonText = "Select"; // loginService.resourceStrings["SELECT_DATA_CARD_CHGS"];
            scope.filesLabel = loginService.resourceStrings["UNDO_CHECK_OUT_OF_UNCHANGED_CHILDREN_LABEL"];
            scope.OK = loginService.resourceStrings["OK"]; // "OK";
            scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";
            // dialog config columns
            scope.doColumns();

            // For each selection item, add a row to the grid.
            scope.itemsToCheck = [];
            scope.gridOptions.data = [];

            zcs.GetLocalVirtualLibraryPath(true).then(function (data) {
                scope.localVirtualLibraryPath = data;
                // Start the loop.
                var workNumber = 0;
                //doLoadLoop(scope.slx.list, workNumber).then(function () {
                selectionCommandService.UnchangedChildrenList(scope.slx).then(function (response) {
                
                    var unchangedChildrenResponse = response.data;

                    var fileInfoModelList = [];
                    angular.forEach(unchangedChildrenResponse.responseList, function (item) {
                        fileInfoModelList.push({ fileId: item.selectionItem.fileId, filePNE: item.filePNE, lastWriteTimeUTC: "" });
                    });

                    var index = 0;
                    var slxUnchanged = { mode: 0, order: 0, list: [] };
                    // Now itemsToCheck has children that are OUT.
                    zcs.GetFileInfos(fileInfoModelList).then(function (response) {
                        fileInfoModelList = response;
                        angular.forEach(unchangedChildrenResponse.responseList, function (item) {
                            angular.forEach(fileInfoModelList, function (fim) {
                                if (item.selectionItem.fileId == fim.fileId) {
                                    var hasFileChange = true;
                                    var d1 = item.previousUTC;
                                    var d2 = fim.lastWriteTimeUTC;
                                    if (item.bIsLinked == false)
                                        hasFileChange = false;
                                    else if (d1 != null
                                        && d1.length > 0
                                        && d1 == d2) {
                                        hasFileChange = false;
                                    }
                                    var hasDataCardChange = item.bDataCardHasChanged;

                                    if(!hasFileChange) {
                                        // match - so unchanged - so add
                                        slxUnchanged.list.push(item.selectionItem);
                                        scope.gridOptions.data.push({
                                            index: index,
                                            selectionItem: item.selectionItem,
                                            isSelected: true,
                                            name: item.selectionItem.filename,
                                            hasFileChange: hasFileChange ? 'T' : 'F',
                                            hasDataCardChange: hasDataCardChange ? 'T' : 'F',
                                            library: item.selectionItem.detailedInfo.libName,
                                            status: item.selectionItem.detailedInfo.status,
                                            filedate: item.selectionItem.detailedInfo.fileUtc,
                                            prevfiledate: item.previousUTC,
                                            filePNE: item.filePNE
                                        });
                                        index++;
                                    }
                                }
                            });
                        });

                        if (slxUnchanged.list.length < 1) {
                            $rootScope.msgBoxShow(loginService.resourceStrings["NO_UNCHANGED_CHILDREN"], "", 1);
                            $mdDialog.hide();
                            return;
                        }

                        //////gridApi.grid.sortColumn();
                        /////gridApi.grid.notifyDataChange(uiGridConstants.dataChange.ALL);
                        scope.gridOptions.data.sort(function (a, b) {
                            if (a.name < b.name)
                                return -1;
                            if (a.name > b.name)
                                return 1;
                            return 0;
                        });

                        // Enables.
                        scope.selectItem();

                        // Do modal.
                        scope.releaseCheckoutDialogShown = true;
                        $timeout(function () {
                            refreshGrid();
                            scope.gridApi.selection.selectAllRows();
                            $timeout(function () {
                                refreshGrid();
                            }, 2000);
                        }, 500);
                    }, function () {

                    });
                }, function (response) {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });
            }, function (response) {
                // Handle error.
                $mdDialog.hide();
                selectionCommandService.ShowEx(response); scope.xyz.processing = false;
            });
        };


        scope.doColumns = function () {
            // dialog config columns
            var colName = loginService.resourceStrings["SCHEMA_S_LONGNAME"];
            var colLibrary = loginService.resourceStrings["SCHEMA_S_LIBNAME"];
            //var colStatus = loginService.resourceStrings["SCHEMA_S_STATUS"];
            //var colFileUTC = loginService.resourceStrings["SCHEMA_S_FILEUTC"];

            scope.gridOptions.columnDefs[0].name = colName;
            scope.gridOptions.columnDefs[1].name = colLibrary;
            //scope.gridOptions.columnDefs[4].name = colFileUTC;
        }

        scope.onDisableTest = function () {
            scope.xyz.processing = !scope.xyz.processing;
        }

        scope.changeSelect = function (bSelect) {
            angular.forEach(scope.gridOptions.data, function (item) {
                if (item.hasDataCardChange == "T") {
                    if (bSelect)
                        scope.gridApi.selection.selectRow(item);
                    else
                        scope.gridApi.selection.unSelectRow(item);
                }
            });
            //var selCount = scope.gridApi.selection.getSelectedRows().length;
            //$timeout(function () {
            //    refreshGrid();
            //}, 500);
        }
        scope.onUnselect = function () {
            scope.changeSelect(false);
        }
        scope.onSelect = function () {
            scope.changeSelect(true);
        }

        scope.onUndoCheckOutOfUnchangedChildrenDialogOK = function () {
            scope.xyz.processing = true;

            var filePNEList = [];
            var slxToDo = { mode: 0, order: 0, list: [] };
            angular.forEach(scope.gridApi.selection.getSelectedRows(), function (gridItem) {
                // If checked.
                filePNEList.push(gridItem.filePNE);
                slxToDo.list.push(gridItem.selectionItem);

            });

            zcs.TestAccessList(filePNEList).then(function (response) {
                if (response.length > 0) {
                    var msg = loginService.resourceStrings["FILES_ARE_IN_USE"] + "\n";
                    angular.forEach(response, function (item) {
                        msg = msg + item + "\n";
                    });
                    scope.xyz.processing = false;
                    $rootScope.msgBoxShow(msg, "");
                    return;
                }

                // Execute.
                selectionCommandService.DeleteDoc(slxToDo).then(function (response) {
                    var selectionCommandResults = response.data;
                    var slx = selectionCommandResults.slx;

                    // Final file ops.
                    if (selectionCommandResults.fileOperationPacket) {
                        // Call ACS to do the file operations for the deletes.
                        zcs.ProcessFileOperationPacket(selectionCommandResults.fileOperationPacket).then(function (response) {
                        }, function (response) {
                            selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                        });
                    }

                    // Handle errors.
                    var atLeastOneError = false;
                    angular.forEach(slx.list, function (item) {
                        if (atLeastOneError == false) {
                            if (item.ec != 0) {
                                atLeastOneError = true;
                                if (atLeastOneError) {
                                    commandService.launchErrors({ slx: slx });
                                }
                            }
                        }
                    });
                    // Close dialog and refresh grid.
                    $mdDialog.hide();
                    scope.xyz.processing = false;

                    // Paul.Ligowski ABC OUT from ABC IN. Creates ABC IN which is the update, and XYZ DUP which isn't anywhere.
                    // So, don't update. Instead, reload.
                    //gridDataService.updateGridRecords(slx.list);
                    gridDataService.reloadGrid();

                    //editEmailsService.showEditEmailsDialog(selectionCommandResults.emails);
                }, function () {
                    selectionCommandService.ShowEx(response); scope.xyz.processing = false;
                });
            });
        };

        scope.onUndoCheckOutOfUnchangedChildrenDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.undoCheckOutOfUnchangedChildrenDialogClosed = function () {

        }

        scope.doEnables = function () {
            scope.xyz.bReadyForOK = scope.gridApi.selection.getSelectedRows().length > 0;
        }

        scope.selectItem = function (item) { 
            scope.doEnables();
        }

        var refreshGrid = function () {
            scope.gridApi.grid.handleWindowResize();
            scope.gridApi.grid.refreshCanvas();
            scope.gridApi.grid.refresh();
        }

        var onRegisterApi = function (gridApi) {
            scope.gridApi = gridApi;
            gridApi.selection.on.rowSelectionChanged(scope, scope.selectItem);
            gridApi.selection.on.rowSelectionChangedBatch(scope, scope.selectItem);
            scope.onUndoCheckOutOfUnchangedChildrenButtonClicked(records);
        }

        scope.gridApi = {};

        scope.gridOptions = {
            data: [],
            enableSelectionBatchEvent: true,
            multiSelect: true,
            modifierKeysToMultiSelect: false, // true, // support ctrl and shift
            enableFullRowSelection: true, // true, // true to have clicking on the row do selection
            enableRowHeaderSelection: true, // false, // true to show the checkbox
            enableSorting: true, // ADDED THIS - true for autosort when click header
            useExternalSorting: true, // true,
            enableColumnMenus: false,
            enableColumnResizing: true,
            columnDefs: [
                { name: 'Name', field: 'name', width: '20%', minWidth: '100' },
                { name: 'Library', field: 'library', width: '20%', minWidth: '100' }
            ],
            onRegisterApi: onRegisterApi
        }

        activate();

        function activate() { }
    }
})();
